import { createFileRoute } from '@tanstack/react-router';
import { ActivityLogsRouteView } from '@/pages/workspaces/activity-logs/routing';

function ProfileActivityRoute() {
  const { workspaceId, tab } = Route.useParams();
  return <ActivityLogsRouteView workspaceId={workspaceId} tab={tab} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/profile_activity/$tab')({
  component: ProfileActivityRoute,
});
